module.exports = __webpack_public_path__ + "img/instagramestory6.5b137eb9.jpg";